"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugTrace = exports.CofStepInfo = exports.AbStepInfo = exports.CofStep = exports.AbStep = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "snapchat.cdp.cof";
/** Steps for AB process. */
var AbStep;
(function (AbStep) {
    AbStep[AbStep["USER_WHITELISTED"] = 0] = "USER_WHITELISTED";
    AbStep[AbStep["USER_GROUP_WHITELISTED"] = 1] = "USER_GROUP_WHITELISTED";
    AbStep[AbStep["FILTER_CONDITIONS"] = 2] = "FILTER_CONDITIONS";
    AbStep[AbStep["SLICE_RANGE"] = 3] = "SLICE_RANGE";
    AbStep[AbStep["TRAFFIC_ALLOCATED"] = 4] = "TRAFFIC_ALLOCATED";
    AbStep[AbStep["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AbStep = exports.AbStep || (exports.AbStep = {}));
/** Steps for COF process. */
var CofStep;
(function (CofStep) {
    CofStep[CofStep["VALIDATE_REQUEST"] = 0] = "VALIDATE_REQUEST";
    CofStep[CofStep["REQUEST_ATLAS"] = 1] = "REQUEST_ATLAS";
    CofStep[CofStep["BUILD_TARGETING_INFO"] = 2] = "BUILD_TARGETING_INFO";
    CofStep[CofStep["QUERY_INDEX"] = 3] = "QUERY_INDEX";
    CofStep[CofStep["REQUEST_AB"] = 4] = "REQUEST_AB";
    CofStep[CofStep["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CofStep = exports.CofStep || (exports.CofStep = {}));
const baseAbStepInfo = { abStep: 0, info: "" };
exports.AbStepInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.abStep !== 0) {
            writer.uint32(8).int32(message.abStep);
        }
        if (message.info !== "") {
            writer.uint32(18).string(message.info);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAbStepInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abStep = reader.int32();
                    break;
                case 2:
                    message.info = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAbStepInfo);
        if (object.abStep !== undefined && object.abStep !== null) {
            message.abStep = object.abStep;
        }
        else {
            message.abStep = 0;
        }
        if (object.info !== undefined && object.info !== null) {
            message.info = object.info;
        }
        else {
            message.info = "";
        }
        return message;
    },
};
const baseCofStepInfo = { cofStep: 0, info: "" };
exports.CofStepInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cofStep !== 0) {
            writer.uint32(8).int32(message.cofStep);
        }
        if (message.info !== "") {
            writer.uint32(18).string(message.info);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCofStepInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cofStep = reader.int32();
                    break;
                case 2:
                    message.info = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseCofStepInfo);
        if (object.cofStep !== undefined && object.cofStep !== null) {
            message.cofStep = object.cofStep;
        }
        else {
            message.cofStep = 0;
        }
        if (object.info !== undefined && object.info !== null) {
            message.info = object.info;
        }
        else {
            message.info = "";
        }
        return message;
    },
};
const baseDebugTrace = { budgetGroupId: 0 };
exports.DebugTrace = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.lastCofStep !== undefined) {
            exports.CofStepInfo.encode(message.lastCofStep, writer.uint32(10).fork()).ldelim();
        }
        if (message.lastAbStep !== undefined) {
            exports.AbStepInfo.encode(message.lastAbStep, writer.uint32(18).fork()).ldelim();
        }
        if (message.budgetGroupId !== 0) {
            writer.uint32(24).uint32(message.budgetGroupId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDebugTrace);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lastCofStep = exports.CofStepInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lastAbStep = exports.AbStepInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.budgetGroupId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDebugTrace);
        if (object.lastCofStep !== undefined && object.lastCofStep !== null) {
            message.lastCofStep = exports.CofStepInfo.fromPartial(object.lastCofStep);
        }
        else {
            message.lastCofStep = undefined;
        }
        if (object.lastAbStep !== undefined && object.lastAbStep !== null) {
            message.lastAbStep = exports.AbStepInfo.fromPartial(object.lastAbStep);
        }
        else {
            message.lastAbStep = undefined;
        }
        if (object.budgetGroupId !== undefined && object.budgetGroupId !== null) {
            message.budgetGroupId = object.budgetGroupId;
        }
        else {
            message.budgetGroupId = 0;
        }
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=debug_info.js.map